import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "./style/main.scss";

import { Navbar } from "./components";
import { Logo } from "./icons";
import { Layout } from "./common/layout";
import { HomePage } from "./pages/HomePage";
import { PublicationsPage } from "./pages/PublicationsPage";
import ArticlesPage from "./pages/ArticlesPage";
import CertificationsPage from "./pages/CertificationsPage";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
  //local state
  const [isLoading, setIsLoading] = useState<boolean>(true);

  //showing off logo after some seconds
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      {/* Loading overlay - renders ON TOP of content so DOM is always available for crawlers */}
      {isLoading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9999,
          background: '#100E0D',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Logo isLoading={true} />
        </div>
      )}
      <div
        className="app-container"
        style={{
          position: 'relative',
          width: '100%',
          minHeight: '100vh',
          overflow: 'hidden',
          background:
            'radial-gradient(circle at top, rgba(196, 149, 106, 0.05), transparent 36%), #100E0D'
        }}
      >
        {/* Universal Navbar - Fixed and transparent */}
        <Navbar />

        {/* Scrollable Content */}
        <div style={{
          position: 'relative',
          zIndex: 10,
          background: 'transparent'
        }}>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/publications" element={<PublicationsPage />} />
              <Route path="/articles" element={<ArticlesPage />} />
              <Route path="/certifications" element={<CertificationsPage />} />
            </Routes>
          </Layout>
        </div>
      </div>
    </Router>
  );
};

export default App;
